import { useMemo } from "react"
import { useAppSelector } from "integrations/redux/hooks"
import { selectFireById } from "features/entity-caching/fires/selectors"
import {
    selectActiveWorkspace,
    selectLegacyWorkspaceTree,
} from "features/data-management/workspace/WorkspaceManagementSlice"
import { findTagAncestors } from "features/data-management/workspace/module"

export const useProjectBreadcrumbLabel = (projectId: string | undefined): string[] => {
    const project = useAppSelector(selectFireById(projectId))
    const workspace = useAppSelector(selectActiveWorkspace())
    const tree = useAppSelector(selectLegacyWorkspaceTree)

    return useMemo(() => {
        const parts: string[] = []
        if (workspace?.name) parts.push(workspace.name)

        if (project?.tagId && project.tagId !== "root" && tree) {
            for (const folder of findTagAncestors(tree, project.tagId)) {
                parts.push(folder.name)
            }
        }

        if (project?.name) parts.push(project.name)
        return parts
    }, [workspace?.name, tree, project?.tagId, project?.name])
}
